import request from '@/utils/request'

// getDwgCountByPO
export function getDwgCountByPO(param) {
  let data = param
  return request({
    url: `/common/getDwgCountByPO`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getDwgListByPO
export function getDwgListByPO(param) {
  let data = param
  return request({
    url: `/common/getDwgListByPO`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getDwgCountByQuot
export function getDwgCountByQuot(param) {
  let data = param
  return request({
    url: `/common/getDwgCountByQuot`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getDwgListByQuot
export function getDwgListByQuot(param) {
  let data = param
  return request({
    url: `/common/getDwgListByQuot`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getDwgCountByPor
export function getDwgCountByPor(param) {
  let data = param
  return request({
    url: `/common/getDwgCountByPor`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getDwgListByPor
export function getDwgListByPor(param) {
  let data = param
  return request({
    url: `/common/getDwgListByPor`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getShipNoList1
export function getShipNoList1(param) {
  let data = param
  return request({
    url: `/common/getShipNoList1`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// epms9000_block
export function epms9000_block(param) {
  let data = param
  return request({
    url: `/common/epms9000_block`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// epms9000_por_no
export function epms9000_por_no(param) {
  let data = param
  return request({
    url: `/common/epms9000_por_no`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function reportView(param) {
  let data = param

  return request({
    url: `/common/reportView`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('res', res)
    
    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/pdf' })
    const blobURL = URL.createObjectURL(blob)
    window.open(blobURL, "", "width=1024, height=700, scrollbars=no, directories=no, location=no, menubar=no, resizable=no, status=yes, toolbar=no")
    })
}

export function ftpDownload(url, fileName) {
  const filePath = url.replace(/http:\/\/192.168.50.11\//g, '').replace(/http:\/\/ebiz.hvs.com.vn\//g, '')
  const orgFileNameArr = filePath.split('/')
  const orgFileName = orgFileNameArr[orgFileNameArr.length - 1]
  const extension = orgFileName.split('.')

  // console.log('filePath', filePath)

  return request({
    url: `/ftpDownload/${filePath}`,
    method: 'GET',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' }
  }).then(res => {
    // console.log('res', res)

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }

    const blob = new Blob([bytes])
    const blobURL = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobURL

    if(fileName) {
      link.download = `${fileName}.${extension[1]}`
    } else {
      link.download = orgFileName
    } 

    document.body.appendChild(link)

    link.click()

    document.body.removeChild(link)
  })
}

export function ftpDownloadViewer(url, fileName) {  
  const orgFileNameArr = url.split('/')
  const orgFileName = orgFileNameArr[orgFileNameArr.length - 1]
  const extension = orgFileName.split('.')

  return request({
    url: `/ftpDownload/${url}`,
    method: 'GET',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' }
  })
}

export function fileDownload(param) {
  // filePath(required), fileName(not required)
  let data = param

  return request({
    url: `/common/fileDownload`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('res', res)
    
    const binaryString = window.atob(res.file)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    // const blob = new Blob([bytes], { type: res.fileType })
    // if(res.fileType.toUpperCase() === 'PDF') {
    //   const blob = new Blob([bytes], { type: 'application/pdf' })
    //   const blobURL = URL.createObjectURL(blob)
    //   window.open(blobURL, "/")
    // } else {
      const blob = new Blob([bytes])
      const blobURL = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobURL

      if(param.fileName) {
        link.download = `${param.fileName}.${res.fileType}`
      } else {
        link.download = res.fileName
      } 

      document.body.appendChild(link)

      link.click()

      document.body.removeChild(link)
    // }
  })
}

export function getRequestList(param) {
  let data = param
  return request({
    url: `/common/getRequestList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function getWasteSellList(param) {
  let data = param
  return request({
    url: `/common/getWasteSellList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function goReceive(param) {
  let data = param
  return request({
    url: `/common/goReceive`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getQuotNoList
export function getQuotNoList(param) {
  let data = param
  return request({
    url: `/common/getQuotNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getRequestHead
export function getRequestHead(param) {
  let data = param
  return request({
    url: `/common/getRequestHead`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getRequestDetail
export function getRequestDetail(param) {
  let data = param
  return request({
    url: `/common/getRequestDetail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getPipeQuotYn
export function getPipeQuotYn(param) {
  let data = param
  return request({
    url: `/common/getPipeQuotYn`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getPipeYn
export function getPipeYn(param) {
  let data = param
  return request({
    url: `/common/getPipeYn`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getSave1020Check
export function getSave1020Check(param) {
  let data = param
  return request({
    url: `/common/getSave1020Check`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getSubmitDetail
export function getSubmitDetail(param) {
  let data = param
  return request({
    url: `/common/getSubmitDetail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getSubmitDetail1
export function getSubmitDetail1(param) {
  let data = param
  return request({
    url: `/common/getSubmitDetail1`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getSubmitFile
export function getSubmitFile(param) {
  let data = param
  return request({
    url: `/common/getSubmitFile`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getPrintRequestSheetA
export function getPrintRequestSheetA(param) {
  let data = param
  return request({
    url: `/common/getPrintRequestSheetA`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getQuotStep
export function getQuotStep(param) {
  let data = param
  return request({
    url: `/common/getQuotStep`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getAcc
export function getAcc(param) {
  let data = param
  return request({
    url: `/common/getAcc`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getAccCd
export function getAccCd(param) {
  let data = param
  return request({
    url: `/common/getAccCd`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getAccGrp
export function getAccGrp(param) {
  let data = param
  return request({
    url: `/common/getAccGrp`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// setSubmit1020ACC
export function setSubmit1020ACC(param) {
  let data = param
  return request({
    url: `/common/setSubmit1020ACC`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// delete1020ACC
export function delete1020ACC(param) {
  let data = param
  return request({
    url: `/common/delete1020ACC`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// setSave1020Det
export function setSave1020Det(param) {
  let data = param
  return request({
    url: `/common/setSave1020Det`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// setSubmit1020Det
export function setSubmit1020Det(param) {
  let data = param
  return request({
    url: `/common/setSubmit1020Det`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getSysDate
export function getSysDate(param) {
  let data = param
  return request({
    url: `/common/getSysDate`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getCarList
export function getCarList(param) {
  let data = param
  return request({
    url: `/common/getCarList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getDriverList
export function getDriverList(param) {
  let data = param
  return request({
    url: `/common/getDriverList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// executeDwgViewer
export function getDwgTicket(param) {
  let data = param
  return request({
    url: `/common/getDwgTicket`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}


export function updatePassword(param) {
  let data = param
  return request({
      url: `/common/updatePassword`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
  })
}

//'.', ',', '?', '!', '/', '*', '+', '-', 
//'0', '1','2','3','4','5','6','7','8','9'
export function fn_uni2nomark(inputStr){
  let strReturn = '';        
                let na = ['á', 'à', 'ả', 'ã', 'ạ', 'â', 'ấ', 'ầ', 'ẩ', 'ẫ', 'ậ', 'ă', 'ắ', 'ằ', 'ẳ', 'ẵ', 'ặ', 
                          'Á', 'À', 'Ả', 'Ã', 'Ạ', 'Â', 'Ấ', 'Ầ', 'Ẩ', 'Ẫ', 'Ậ', 'Ă', 'Ắ', 'Ằ', 'Ẳ', 'Ẵ', 'Ặ',
                          'í', 'ì', 'ỉ', 'ĩ', 'ị', 'Í', 'Ì', 'Ỉ', 'Ĩ', 'Ị',
                          'é', 'è', 'ẻ', 'ẽ', 'ẹ', 'ê', 'ế', 'ề', 'ể', 'ễ', 'ệ', 'É', 'È', 'Ẻ', 'Ẽ', 'Ẹ', 'Ê', 'Ế', 'Ề', 'Ể', 'Ễ', 'Ệ',
                          'ó', 'ò', 'ỏ', 'õ', 'ọ', 'ô', 'ố', 'ồ', 'ổ', 'ỗ', 'ộ', 'ơ', 'ớ', 'ờ', 'ở', 'ỡ', 'ợ',
                          'Ó', 'Ò', 'Ỏ', 'Õ', 'Ọ', 'Ô', 'Ố', 'Ồ', 'Ổ', 'Ỗ', 'Ộ', 'Ơ', 'Ớ', 'Ờ', 'Ở', 'Ỡ', 'Ợ',
                          'ú', 'ù', 'ủ', 'ũ', 'ụ', 'ư', 'ứ', 'ừ', 'ử', 'ữ', 'ự',
                          'Ú', 'Ù', 'Ủ', 'Ũ', 'Ụ', 'Ư', 'Ứ', 'Ừ', 'Ử', 'Ữ', 'Ự', 'Đ', 'đ', 
                          'ý', 'ỳ', 'ỷ', 'ỹ', 'ỵ', 'Ý', 'Ỳ', 'Ỷ', 'Ỹ', 'Ỵ'];

                let newna = ['a', 'a', 'a', 'a', 'a', 'a', 'a', 'a', 'a', 'a', 'a', 'a', 'a', 'a', 'a', 'a', 'a', 
                             'A', 'A', 'A', 'A', 'A', 'A', 'A', 'A', 'A', 'A', 'A', 'A', 'A', 'A', 'A', 'A', 'A',
                            'i', 'i', 'i', 'i', 'i', 'I', 'I', 'I', 'I', 'I',                           
                            'e', 'e', 'e', 'e', 'e', 'e', 'e', 'e', 'e', 'e', 'e',                            
                            'E', 'E', 'E', 'E', 'E', 'E', 'E', 'E', 'E', 'E', 'E',                           
                            'o', 'o', 'o', 'o', 'o', 'o', 'o', 'o', 'o', 'o', 'o', 'o', 'o', 'o', 'o', 'o', 'o', 
                            'O', 'O', 'O', 'O', 'O', 'O', 'O', 'O', 'O', 'O', 'O', 'O', 'O', 'O', 'O', 'O', 'O',                            
                            'u', 'u', 'u', 'u', 'u', 'u', 'u', 'u', 'u', 'u', 'u',
                            'U', 'U', 'U', 'U', 'U', 'Ö', 'U', 'U', 'U', 'U', 'U', 'D', 'd', 
                            'y','y','y','y','y', 'Y', 'Y', 'Y', 'Y', 'Y'];          

                let i = 0, strLen = inputStr.length;
                let chkChr = '';              

                for(i = 0; i <= strLen - 1; i++)
                {
                    chkChr = inputStr.substr(i,1);                    
                   
                    if ( na.indexOf(chkChr)>= 0){

                        strReturn = strReturn + newna[na.indexOf(chkChr)];                     
                    }
                    else strReturn = strReturn + chkChr;
                }

                //console.log(strReturn)  ;          
    return  strReturn;               
}

export function fn_uni2vni(inputStr){
  let strReturn = '';        
                let pa = ['b', 'c', 'd', 'f', 'g', 'h', 'j', 'k', 'l','m','n', 'p', 'q', 'r', 's', 't', 'v', 'w','x', 'y', 'z', ' ',
                           'B', 'C', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'M','N', 'P', 'Q', 'R', 'S', 'T', 'V', 'W', 'X', 'Y', 'X', 
                           'a', 'e', 'i', 'o', 'u', 'A', 'E', 'I', 'O', 'U' ];        
                
                let na = ['á', 'à', 'ả', 'ã', 'ạ', 'â', 'ấ', 'ầ', 'ẩ', 'ẫ', 'ậ', 'ă', 'ắ', 'ằ', 'ẳ', 'ẵ', 'ặ', 
                          'Á', 'À', 'Ả', 'Ã', 'Ạ', 'Â', 'Ấ', 'Ầ', 'Ẩ', 'Ẫ', 'Ậ', 'Ă', 'Ắ', 'Ằ', 'Ẳ', 'Ẵ', 'Ặ',
                          'í', 'ì', 'ỉ', 'ĩ', 'ị', 'Í', 'Ì', 'Ỉ', 'Ĩ', 'Ị',
                          'é', 'è', 'ẻ', 'ẽ', 'ẹ', 'ê', 'ế', 'ề', 'ể', 'ễ', 'ệ', 'É', 'È', 'Ẻ', 'Ẽ', 'Ẹ', 'Ê', 'Ế', 'Ề', 'Ể', 'Ễ', 'Ệ',
                          'ó', 'ò', 'ỏ', 'õ', 'ọ', 'ô', 'ố', 'ồ', 'ổ', 'ỗ', 'ộ', 'ơ', 'ớ', 'ờ', 'ở', 'ỡ', 'ợ',
                          'Ó', 'Ò', 'Ỏ', 'Õ', 'Ọ', 'Ô', 'Ố', 'Ồ', 'Ổ', 'Ỗ', 'Ộ', 'Ơ', 'Ớ', 'Ờ', 'Ở', 'Ỡ', 'Ợ',
                          'ú', 'ù', 'ủ', 'ũ', 'ụ', 'ư', 'ứ', 'ừ', 'ử', 'ữ', 'ự',
                          'Ú', 'Ù', 'Ủ', 'Ũ', 'Ụ', 'Ư', 'Ứ', 'Ừ', 'Ử', 'Ữ', 'Ự', 'Đ', 'đ', 
                          'ý', 'ỳ', 'ỷ', 'ỹ', 'ỵ', 'Ý', 'Ỳ', 'Ỷ', 'Ỹ', 'Ỵ'];

                let newna = ['aù', 'aø', 'aû', 'a4', 'aï', 'aâ', 'aá', 'aà', 'aå', 'a9', 'aä', 'aê', 'aé', 'aè', 'aú', 'aü', 'aë', 
                             'AÙ', 'AØ', 'AÛ', 'A4', 'AÏ', 'AÂ', 'AÁ', 'AÀ', 'AÅ', 'A9', 'AÄ', 'AÊ', 'AÉ', 'AÈ', 'AÚ', 'AÜ', 'AË',
                            'í', 'i2', 'æ', 'ó', 'i5', 'Í', 'I2', 'Æ', 'Ó', 'I5',                           
                            'eù', 'eø', 'eû', 'e4', 'eï', 'eâ', 'eá', 'eà', 'eå', 'e9', 'eä',                            
                            'EÙ', 'EØ', 'EÛ', 'EÕ', 'EÏ', 'EÂ', 'EÁ', 'EÀ', 'EÅ', 'EÃ', 'EÄ',                           
                            'où', 'oø', 'oû', 'oõ', 'oï', 'oâ', 'oá', 'oà', 'oå', 'o9', 'oä', 'ô', 'ôù', 'ôø', 'ôû', 'o9', 'ôï', 
                            'OÙ', 'OØ', 'OÛ', 'OÕ', 'OÏ', 'OÂ', 'OÁ', 'OÀ', 'OÅ', 'OÃ', 'OÄ', 'Ô', 'ÔÙ', 'ÔØ', 'ÔÛ', 'O9', 'ÔÏ',                            
                            'uù', 'uø', 'uû', 'u4', 'uï', 'ö', 'öù', 'öø', 'öû', 'u9', 'öï',
                            'UÙ', 'UØ', 'UÛ', 'U4', 'UÏ', 'Ö', 'ÖÙ', 'ÖØ', 'ÖÛ', 'ÖÕ', 'ÖÏ', 'Ñ', 'ñ', 
                            'yù', 'yø', 'yû', 'yõ', 'î',  'YÙ', 'YØ', 'YÛ', 'YÕ', 'Î'];          

                let i = 0, strLen = inputStr.length;
                let chkChr = '';              

                for(i = 0; i <= strLen - 1; i++)
                {
                    chkChr = inputStr.substr(i,1);                    
                //    console.log(chkChr)

                    if ( pa.includes(chkChr) )
                    {
                        strReturn = strReturn + chkChr;                
                    }                    
                   else if ( na.indexOf(chkChr)>= 0){

                        strReturn = strReturn + newna[na.indexOf(chkChr)];                     
                    }
                    else strReturn = strReturn + chkChr;
                }
    return  strReturn;               
}

//'.', ',', '?', '!', '/', '*', '+', '-', '0', '1','2','3','4','5','6','7','8','9'

export function fn_vni2uni(inputStr)  {        
  let strReturn = '';        
  let pa = ['b', 'c', 'd', 'f', 'g', 'h', 'j', 'k', 'l','m','n', 'p', 'q', 'r', 's', 't', 'v', 'w','x', 'z', ' ',
             'B', 'C', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'M','N', 'P', 'Q', 'R', 'S', 'T', 'V', 'W', 'X'  
             ];      

  let nas = ['a', 'e', 'i', 'o', 'u', 'y', 'A', 'E', 'I', 'O', 'U', 'Y','ö', 'Ö', 'ô', 'Ô', 'Ö'];        

  let na = ['aù', 'aø', 'aû', 'a4', 'aï', 'aâ', 'aá', 'aà', 'aå', 'a9', 'aä', 'aê', 'aé', 'aè', 'aú', 'aü', 'aë', 
            'AÙ', 'AØ', 'AÛ', 'A4', 'AÏ', 'AÂ', 'AÁ', 'AÀ', 'AÅ', 'A9', 'AÄ', 'AÊ', 'AÉ', 'AÈ', 'AÚ', 'AÜ', 'AË',
            'í', 'i2', 'æ', 'ó', 'i5', 'Í', 'Ì', 'Æ', 'Ó', 'I5',                           
            'eù', 'eø', 'eû', 'e4', 'eï', 'eâ', 'eá', 'eà', 'eå', 'e9', 'eä',                            
            'EÙ', 'EØ', 'EÛ', 'EÕ', 'EÏ', 'EÂ', 'EÁ', 'EÀ', 'EÅ', 'EÃ', 'EÄ',                           
            'où', 'oø', 'oû', 'oõ', 'oï', 'oâ', 'oá', 'oà', 'oå', 'o9', 'oä', 'ô', 'ôù', 'ôø', 'ôû', 'o9', 'ôï', 
            'OÙ', 'OØ', 'OÛ', 'OÕ', 'OÏ', 'OÂ', 'OÁ', 'OÀ', 'OÅ', 'OÃ', 'OÄ', 'Ô', 'ÔÙ', 'ÔØ', 'ÔÛ', 'O9', 'ÔÏ',                            
            'uù', 'uø', 'uû', 'u4', 'uï', 'ö', 'öù', 'öø', 'öû', 'u9', 'öï',
            'UÙ', 'UØ', 'UÛ', 'U4', 'UÏ', 'Ö', 'ÖÙ', 'ÖØ', 'ÖÛ', 'ÖÕ', 'ÖÏ', 'Ñ', 'ñ', 
            'yù', 'yø', 'yû', 'yõ', 'î',  'YÙ', 'YØ', 'YÛ', 'YÕ', 'Î' ];      

  let newna = ['á', 'à', 'ả', 'ã', 'ạ', 'â', 'ấ', 'ầ', 'ẩ', 'ẫ', 'ậ', 'ă', 'ắ', 'ằ', 'ẳ', 'ẵ', 'ặ', 
              'Á', 'À', 'Ả', 'Ã', 'Ạ', 'Â', 'Ấ', 'Ầ', 'Ẩ', 'Ẫ', 'Ậ', 'Ă', 'Ắ', 'Ằ', 'Ẳ', 'Ẵ', 'Ặ',
              'í', 'ì', 'ỉ', 'ĩ', 'ị', 'Í', 'Ì', 'Ỉ', 'Ĩ', 'Ị',
              'é', 'è', 'ẻ', 'ẽ', 'ẹ', 'ê', 'ế', 'ề', 'ể', 'ễ', 'ệ', 
              'É', 'È', 'Ẻ', 'Ẽ', 'Ẹ', 'Ê', 'Ế', 'Ề', 'Ể', 'Ễ', 'Ệ',
              'ó', 'ò', 'ỏ', 'õ', 'ọ', 'ô', 'ố', 'ồ', 'ổ', 'ỗ', 'ộ', 'ơ', 'ớ', 'ờ', 'ở', 'ỡ', 'ợ',
              'Ó', 'Ò', 'Ỏ', 'Õ', 'Ọ', 'Ô', 'Ố', 'Ồ', 'Ổ', 'Ỗ', 'Ộ', 'Ơ', 'Ớ', 'Ờ', 'Ở', 'Ỡ', 'Ợ',
              'ú', 'ù', 'ủ', 'ũ', 'ụ', 'ư', 'ứ', 'ừ', 'ử', 'ữ', 'ự',
              'Ú', 'Ù', 'Ủ', 'Ũ', 'Ụ', 'Ư', 'Ứ', 'Ừ', 'Ử', 'Ữ', 'Ự', 'Đ', 'đ', 
              'ý', 'ỳ', 'ỷ', 'ỹ', 'ỵ', 'Ý', 'Ỳ', 'Ỷ', 'Ỹ', 'Ỵ'];            

  let i = 0, strLen = inputStr.length;
  let chkChr = '', chkNa;
 
  for(i = 0; i <= strLen - 1; i++)
  {
      chkChr = inputStr.substr(i,1);
     // console.log('chkChr: ' + chkChr);
      /*if ( pa.includes(chkChr))
      {
          strReturn = strReturn + chkChr;                
      }                                        
     else */
     
     if ( nas.indexOf(chkChr)>= 0)
     {
         //console.log('chkChr: ' + chkChr);
         chkNa = chkChr + inputStr.substr(i+1 ,1);
       //  console.log('chkNa: ' + chkNa);

          if ( na.indexOf(chkNa)>= 0 ){                             
              strReturn = strReturn + newna[na.indexOf(chkNa)];
              i++;
          }
          else if ( na.indexOf(chkChr)>= 0 ){                             
          //    console.log('chkChr1: ' + chkChr);
              strReturn = strReturn + newna[na.indexOf(chkChr)];              
          }
          else strReturn = strReturn + chkChr;
  
      }   
      else if (na.includes(chkChr))
      {
         strReturn = strReturn +  newna[na.indexOf(chkChr)];                
      }                                        
      else strReturn = strReturn + chkChr;                    
  }
  
  return  strReturn;    
}